let authConfig: {
	getAccessToken?: () => Promise<string | null>;
	instanceId?: string;
} = {};

export function configureAuth(config: {
	getAccessToken?: () => Promise<string | null>;
	instanceId?: string;
}): void {
	authConfig = config;
}

export function getAuthConfig(): {
	getAccessToken?: () => Promise<string | null>;
	instanceId?: string;
} {
	return authConfig;
}

export async function authFetch(
	input: RequestInfo | URL,
	init?: RequestInit,
): Promise<Response> {
	const headers = new Headers(init?.headers);

	// Extract URL for logging
	let requestUrl: string;
	if (input instanceof Request) {
		requestUrl = input.url;
	} else if (input instanceof URL) {
		requestUrl = input.toString();
	} else {
		requestUrl = String(input);
	}

	if (authConfig.getAccessToken) {
		try {
			const token = await authConfig.getAccessToken();
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
				console.log(
					"%c[authFetch] Attaching bearer token to request:",
					"color: blue;",
					{ url: requestUrl, token },
				);
			} else {
				console.log(
					"%c[authFetch] No token available for request:",
					"color: orange;",
					{ url: requestUrl },
				);
			}
		} catch (error) {
			console.error("Error getting access token:", error);
		}
	} else {
		console.log(
			"%c[authFetch] No getAccessToken function configured.",
			"color: red;",
		);
	}

	// Always set X-Instance-Id header, with fallback if not configured
	const instanceId = authConfig.instanceId || "default-instance";
	headers.set("X-Instance-Id", instanceId);

	return fetch(input, {
		...init,
		headers,
	});
}
